import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './loading-spinner.scss';
export const Spinner = ({ className }) => (React.createElement("div", { "data-hook": "loading-spinner-circle", className: classnames(className, styles.circle) }));
Spinner.propTypes = {
    className: PropTypes.string,
};
//# sourceMappingURL=loading-spinner.js.map